import { InfoIcon } from 'lucide-react';
import React, { useEffect, useState } from 'react'
import { FaMoneyBillTrendUp } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';

function CaseValueDisp({
    userInfo,
    detail
}) {
        const [subscribeToSeeMore, setSubscribeToSeeMore] = useState(false);
        const [subscriptionInfo, setSubscriptionInfo] = useState(false);
        const [caseValue, setCaseValue] = useState({
            lowerValue: "0",
            upperValue: "0"
        });
        const navigate = useNavigate();
        useEffect(() => {
            if(userInfo?.isActiveSubscription)
            {
                if(detail?.aiEstimateLowerValue != null &&  detail?.aiEstimateUpperValue != null)
                {
                    setCaseValue({
                        lowerValue: Number(detail?.aiEstimateLowerValue).toLocaleString('en-US',  {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        }),
                        upperValue: Number(detail?.aiEstimateUpperValue).toLocaleString('en-US',  {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        })
                    });
                }
                else
                {
                    setCaseValue({
                        lowerValue: Number(detail?.aiEstimate?.lowerValue).toLocaleString('en-US',  {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        }),
                                                upperValue: Number(detail?.aiEstimate?.upperValue).toLocaleString('en-US',  {
                        style: 'currency',
                        currency: 'USD',
                        minimumFractionDigits: 0,
                        maximumFractionDigits: 0,
                        })
                    });
                    console.log(
                        "caseValue",caseValue
                    )
                }
            }
           
        },[detail]);
    
  return (
     <div className=' text-green-800 text-sm lg:text-xl    w-max flex justify-center items-center rounded '>
          
     <div className=' relative  font-bold flex cursor-pointer '> 
        
        {userInfo?.isActiveSubscription ? 
        <div className='relative flex items-center justify-center'>
            {caseValue?.lowerValue}&nbsp;to&nbsp;
            {caseValue?.upperValue}
        <InfoIcon 
            onMouseEnter={() => setSubscriptionInfo(true)}
            onMouseLeave={() => setSubscriptionInfo(false)}
        className='w-[16px] h-[16px] ml-1'/>
         {subscriptionInfo &&
            <div className='absolute bg-white w-[280px] text-gray-600 p-2 rounded border top-8 -right-1/2 border-gray-200 shadow-md text-xs'>
                <div className='flex flex-col'>
                    <div className='mb-1'>This is an AI generated estimate of settlement for the case.</div>
                </div>
            </div>
            }
        </div>
        : 
        <span className='text-md'
        onMouseEnter={() => setSubscribeToSeeMore(true)}
            onMouseLeave={() => setSubscribeToSeeMore(false)}
            onClick={()=> navigate("/attorney/subscription")}
        >$<span className='blur-[4px]'>000,000</span> to $<span className='blur-[4px]'>000,000</span> </span>}
            {subscribeToSeeMore &&
            <div className='absolute bg-green-100 w-[280px] text-green-600 p-2 rounded border top-8 -right-1/2 border-green-200 shadow-md text-xs'>
                <div className='flex flex-col'>
                    <div className='mb-1'>This is an AI generated estimate of the case value. Subscribe to see the case value.</div>
                </div>
            </div>
            }
        </div>    
            </div>
  )
}

export default CaseValueDisp
